var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterMobileLinksMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 81,
    viewBox: "0 0 54 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 0C4.57312 0 0 4.57312 0 10.125V70.875C0 76.4269 4.57312 81 10.125 81H43.875C49.4269 81 54 76.4269 54 70.875V10.125C54 4.57312 49.4269 0 43.875 0H10.125ZM10.125 6.75H43.875C45.7481 6.75 47.25 8.25187 47.25 10.125V70.875C47.25 72.7481 45.7481 74.25 43.875 74.25H10.125C8.25187 74.25 6.75 72.7481 6.75 70.875V10.125C6.75 8.25187 8.25187 6.75 10.125 6.75ZM27 64.125C26.1049 64.125 25.2465 64.4806 24.6135 65.1135C23.9806 65.7464 23.625 66.6049 23.625 67.5C23.625 68.3951 23.9806 69.2536 24.6135 69.8865C25.2465 70.5194 26.1049 70.875 27 70.875C27.8951 70.875 28.7536 70.5194 29.3865 69.8865C30.0194 69.2536 30.375 68.3951 30.375 67.5C30.375 66.6049 30.0194 65.7464 29.3865 65.1135C28.7536 64.4806 27.8951 64.125 27 64.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterMobileLinksMobile);
export default __webpack_public_path__ + "static/media/center-mobile-links-mobile.dec6711bf04cd17e0934186adb34f848.svg";
export { ForwardRef as ReactComponent };